import { Maybe } from 'types/FMSGraphqlTypes'
import { TRateTypesSchema } from '../components/RateTypesModal/schema/RateTypesSchema'
import { TCarrierRateTypePreference } from '../types'

export const getRateTypesDefaultValues = (
  rateType: Maybe<TCarrierRateTypePreference>
): TRateTypesSchema => {
  const { allowsAllIn, allowsDayRate, hasLineHaulFuelSurcharge } = rateType || {}
  return {
    allowsAllIn: allowsAllIn || false,
    allowsDayRate: allowsDayRate || false,
    hasLineHaulFuelSurcharge: hasLineHaulFuelSurcharge || false,
  }
}
